import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-106" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-107" data-mp="1mo2182j7gpfa">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-108" data-mp="1mmqz075erpqa">
          <span aria-hidden="true" data-id="element-109" data-mp="tyv5tcf1sfy9">🏆 </span>Special Launch Offer
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-110" data-mp="u0xsbmgzrqy8">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-111" data-mp="p24ratiw5sey">
            DANCE READY™ Pack
          </span>

          <dl data-id="element-112" data-mp="2fbxyb8cosjcl">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-ink/10 py-4 text-sm" data-id="element-113" data-mp="2fad27eaq4scm">
                <dt className="text-ink/80" data-id="element-114" data-mp="pj5tkl34eccf">{row.label}</dt>
                <dd className="font-bold text-brand" data-id="element-115" data-mp="ujbn66sya8x5">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-116" data-mp="ziertq50qd4l">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-117" data-mp="13jqblf17o44v">
                Total Value:
              </dt>
              <dd className="font-bold text-amber-700 line-through" data-id="element-118" data-mp="6uipo5wojt0f">
                $193 USD
              </dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-119" data-mp="bqpwe0wwh8jf">
            Only for today
          </p>
          <p className="flex items-baseline justify-center gap-2 border-b border-ink/10 pb-7 pt-2" data-id="element-120" data-mp="kle19pykco7p">
            <span className="font-display text-6xl font-black leading-none text-brand" data-id="element-121" data-mp="3k9fc07etfeqi">
              $27
            </span>
            <span className="font-display text-xl font-bold text-brand/70" data-id="element-122" data-mp="3o8wfivaom1t1">
              USD
            </span>
          </p>

          <p className="mt-5 text-center text-[11px] font-medium leading-relaxed text-ink/60" data-id="element-123" data-mp="vdnvqlwexx86">
            <span aria-hidden="true" data-id="element-124" data-mp="qejnbxhbc3iw">💳 </span>One-time payment. Lifetime
            access. No subscriptions.
          </p>

          <CtaButton className="mt-4 w-full" data-id="element-125" data-mp="106pfb77keky3" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-126" data-mp="107s7rjkjcvg4">
            Instant Download · One-Time Payment · Lifetime Access · 7-Day
            Guarantee
          </p>
        </div>
      </div>
    </section>;
}